class SlashRouteAction {

    static ON_SLASH_ROUTE = "ON_SLASH_ROUTE";

    static OnSlashRoute(data) {
        return {
            type : this.ON_SLASH_ROUTE,
            data
        }
    }
    
    
}

export default SlashRouteAction;


// WEBPACK FOOTER //
// ./src/store/actions/slashRouteAction.js